/* eslint-disable */
import ExecutaRest from '../util/ExecutaRest'

class SASAPI {

    static ConsultaSAS(parametros) {
        
        var rest = new ExecutaRest();

        return new Promise(function (resolve, reject) {
            rest.Post('FOCOSL.svc/rest/ValidaClienteREST', parametros).then(retorno => {
                
                if (retorno.dado) {
                    
                    resolve(Object.assign({}, retorno));
                } else if (retorno.erro || (retorno.dado === null && retorno.erro === null)) {
                    
                    reject(retorno.erro);
                }

            }).catch(error => {
                
                reject('Ocorreu um erro inesperado em --> ObterMensagemPorProtocoloSenha: ' + error /*areaTratamento.statusText*/);
            });

        });
    }
}

export default SASAPI;


/** WEBPACK FOOTER **
 ** ./src/components/api/sasApi.js
 **/